import makeRequest from './request';
import { response, request } from './interceptors';
import { instance as axios } from './instance';

axios.interceptors.response.use(response.success, response.error);
axios.interceptors.request.use(request.success, request.error);

export default {
  get: function get(endpoint, settings) {
    return makeRequest('get', endpoint, null, settings);
  },
  post: function post(endpoint, body, settings) {
    return makeRequest('post', endpoint, body, settings);
  },
  put: function put(endpoint, body, settings) {
    return makeRequest('put', endpoint, body, settings);
  },
  patch: function patch(endpoint, body, settings) {
    return makeRequest('patch', endpoint, body, settings);
  },
  delete: function _delete(endpoint, body, settings) {
    return makeRequest('delete', endpoint, settings);
  }
};
//# sourceMappingURL=axios.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-api/lib/utils/axios.js
// module id = 27
// module chunks = 0